import { apiClient } from './api';
import { TimesheetApprovalService } from './TimesheetApprovalServiceBase';
export * from './TimesheetApprovalServiceBase';
/** Web timesheet approval service singleton (cookie-auth web client). */
let _webTimesheetApprovalService = null;
function getWebTimesheetApprovalService() {
    if (!_webTimesheetApprovalService) {
        _webTimesheetApprovalService = new TimesheetApprovalService(apiClient);
    }
    return _webTimesheetApprovalService;
}
export const timesheetApprovalService = getWebTimesheetApprovalService();
